import getStripePriceTotalAmount from "./getStripePriceTotalAmount"

export default function getStartingStripePrice(stripePrices = []) {
  let startingPrice
  let startingAmount
  stripePrices.forEach((stripePrice) => {
    let priceAmount = getStripePriceTotalAmount(stripePrice, 1)
    if (!startingPrice || priceAmount < startingAmount) {
      startingPrice = stripePrice
      startingAmount = priceAmount
    }
  })
  return startingPrice
}
